/**
 * MM Análisis Productos
 * Maneja la funcionalidad del modal y tabs
 */

class MMAnalisisModal {
    constructor(element) {
        this.element = element;
        this.modal = null;
        this.currentTab = 'interno';
        this.init();
    }

    init() {
        // Find the associated modal
        const modalId = this.element.getAttribute('data-modal-trigger');
        this.modal = document.getElementById(modalId);

        if (!this.modal) return;

        // Bind events
        this.bindEvents();
        this.setupSearch();
    }

    bindEvents() {
        // Open modal on banner click
        this.element.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
        });

        // Close modal events
        const closeButtons = this.modal.querySelectorAll('[data-modal-close]');
        closeButtons.forEach(button => {
            button.addEventListener('click', () => this.closeModal());
        });

        // Tab switching
        const tabs = this.modal.querySelectorAll('[data-tab]');
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const tabName = tab.getAttribute('data-tab');
                this.switchTab(tabName);
            });
        });

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
                this.closeModal();
            }
        });

        // Prevent scroll propagation on modal content
        const modalContent = this.modal.querySelector('.mm-analisis-modal__content');
        if (modalContent) {
            modalContent.addEventListener('touchmove', (e) => {
                e.stopPropagation();
            });
        }
    }
    setupSearch() {
        const searchInput = this.modal.querySelector('[data-search-input]');
        if (!searchInput) return;

        const productList = this.modal.querySelector('.mm-analisis-modal__product-list');
        if (!productList) return;

        // Real-time search
        searchInput.addEventListener('input', (e) => {
            const searchTerm = e.target.value.trim().toLowerCase();
            const items = productList.querySelectorAll('.mm-analisis-modal__product-item');

            if (searchTerm === '') {
                items.forEach(item => item.style.display = '');
                this.removeNoResults();
                return;
            }

            let visibleCount = 0;
            items.forEach(item => {
                const batch = (item.dataset.batch || '').toLowerCase();
                const variant = (item.dataset.variant || '').toLowerCase();

                if (batch.includes(searchTerm) || variant.includes(searchTerm)) {
                    item.style.display = '';
                    visibleCount++;
                } else {
                    item.style.display = 'none';
                }
            });

            this.updateNoResults(visibleCount, productList);
        });
    }

// Add this method to the MMAnalisisModal class
    removeNoResults() {
        const noResults = this.modal.querySelector('.mm-analisis-modal__no-results');
        if (noResults) noResults.remove();
    }

// Add this method to the MMAnalisisModal class
    updateNoResults(count, container) {
        this.removeNoResults();

        if (count === 0) {
            const noResults = document.createElement('div');
            noResults.className = 'mm-analisis-modal__no-results';
            const noResultsText = container.dataset.noResultsText || 'No se encontraron resultados para tu búsqueda';

            noResults.innerHTML = '<p>'+noResultsText+'</p>';
            container.appendChild(noResults);
        }
    }

    openModal() {
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mm-modal-open');

        // Focus trap
        this.trapFocus();
    }

    closeModal() {
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mm-modal-open');
        const searchInput = this.modal.querySelector('[data-search-input]');
        if (searchInput) {
            searchInput.value = '';
            const items = this.modal.querySelectorAll('.mm-analisis-modal__product-item');
            items.forEach(item => item.style.display = '');
            this.removeNoResults();
        }
    }

    switchTab(tabName) {
        // Update tab buttons
        const tabs = this.modal.querySelectorAll('[data-tab]');
        tabs.forEach(tab => {
            if (tab.getAttribute('data-tab') === tabName) {
                tab.classList.add('mm-analisis-modal__tab--active');
            } else {
                tab.classList.remove('mm-analisis-modal__tab--active');
            }
        });

        // Update panels
        const panels = this.modal.querySelectorAll('[data-panel]');
        panels.forEach(panel => {
            if (panel.getAttribute('data-panel') === tabName) {
                panel.classList.add('mm-analisis-modal__panel--active');
            } else {
                panel.classList.remove('mm-analisis-modal__panel--active');
            }
        });

        this.currentTab = tabName;
        const searchInput = this.modal.querySelector('[data-search-input]');
        if (searchInput) {
            searchInput.value = '';
            const items = this.modal.querySelectorAll('.mm-analisis-modal__product-item');
            items.forEach(item => item.style.display = '');
            this.removeNoResults();
        }

    }

    trapFocus() {
        const focusableElements = this.modal.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        firstFocusable?.focus();

        this.modal.addEventListener('keydown', (e) => {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    lastFocusable?.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    firstFocusable?.focus();
                    e.preventDefault();
                }
            }
        });
    }
}

// Initialize all MM Analisis banners
document.addEventListener('DOMContentLoaded', () => {
    const banners = document.querySelectorAll('[data-modal-trigger^="analisis-modal-"]');
    banners.forEach(banner => {
        new MMAnalisisModal(banner);
    });
});

// Re-initialize on Shopify section load (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
        const banners = document.querySelectorAll('[data-modal-trigger^="analisis-modal-"]');
        banners.forEach(banner => {
            new MMAnalisisModal(banner);
        });
    });
}